export enum MenuButtonEnum {
  SaveClose,
  Reset,
  Undo,
  Redo,
  Validate,
  ToggleNeutralDesignation,
}
